import React, { Component } from 'react'
import moment from 'moment'
import { Input, Alert, Modal, ModalBody, ModalFooter, ModalHeader, Button} from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import { DateRangePicker , DayPickerRangeController} from 'react-dates'
import saveAccountLicense from '../../../helpers/users/licenses/saveAccountLicense'
import deleteAccountLicense from '../../../helpers/users/licenses/deleteAccountLicense'


class ManageLicenseRow extends Component {

  state = {
    startDate: moment(Number(this.props.license.startDate)),
    endDate: moment(Number(this.props.license.endDate)),
    focusedInput: null,
    quantity: Number(this.props.license.licensedMax),
    licenseType: this.props.license.licenseType + '',
    saving: false,
    error: '',
    changed: false,
    deleting: false,
    showQuantity: true,
    showLicenseType : true,
    showModal: false
  }


  handleDatesChange = ({ startDate, endDate }) => this.setState({ startDate, endDate, changed: true })
  focusInput = (focusedInput) => this.setState({ focusedInput })
  handleQtyChange = ({ target }) => this.setState({ quantity: target.value, changed: true })
  handleTypeChange = ({ target }) => this.setState({ licenseType: target.value, changed: true })

  handleSubmit = (e) => {
    e.preventDefault()
    const { startDate, endDate, quantity, licenseType, } = this.state
    const { license, } = this.props
    // form validation
    if (isNaN(Math.round(quantity))) {
      return this.setState({ error: 'Quantity must be set to a number.' })
    } else if (!startDate || !endDate) {
      return this.setState({ error: 'Start and end dates must be set.' })
    }
    this.setState({ saving: true })
    saveAccountLicense({
      id: license.id,
      startDate: startDate.valueOf(),
      endDate: endDate.valueOf(),
      quantity: Math.round(quantity),
      licenseType,
    })
      .then(() => this.setState({ saving: false, error: '', changed: false }))
      .catch((error) => this.setState({ saving: false, error }))
  }
  toggleQuantity() {
    this.setState({ showQuantity: !this.state.showQuantity })
  }
  toggleLicenseType() {
    this.setState({ showLicenseType: !this.state.showLicenseType })
  }

  showPrompt = () => {
    this.setState({ showModal : !this.state.showModal });
  }

  handleDelete = (e) => {
    const { license, } = this.props
    this.setState({ deleting: true, showModal: false })
    deleteAccountLicense(license.id)
      .then(() => this.setState({ deleting: false, error: '', changed: false , showModal : false }))
      .catch(error => this.setState({ deleting: false, error }))
  }

  render() {

    const {
      startDate,
      endDate,
      focusedInput,
      quantity,
      licenseType,
      saving,
      error,
      changed,
      deleting,
      showQuantity,
      showLicenseType
    } = this.state
    const {
      handleDatesChange,
      focusInput,
      handleQtyChange,
      handleSubmit,
      handleTypeChange,
      handleDelete,
      showPrompt
    } = this
    const { license } = this.props
    const { licensedCount, licensedMax, name } = license
    const START_DATE = 'startDate'
    const END_DATE = 'endDate'
    return (
      <React.Fragment><tr>
        <td scope="row">{name}</td>
        <td>{showLicenseType ? <span className="licensetype-text" onClick={this.toggleLicenseType.bind(this)}>{licenseType}</span> : <Input
          name='licenseType'
          id='licenseType'
          type='select'
          value={licenseType}
          onChange={handleTypeChange}
        >
          <option value='student'>Student</option>
          <option value='educator'>Educator</option>
        </Input>}</td>
        <td><span className="quantity-text" onClick={this.toggleQuantity.bind(this)}>{licensedCount} out of {showQuantity && quantity}</span>
          {!showQuantity && <Input
            name='quantity'
            id='quantity'
            type='text'
            value={quantity}
            placeholder={`${licensedCount} out of ${licensedMax} used.`}
            onChange={handleQtyChange}
            inline
            className="quantity-field"
          />}<span className='quantity-text' onClick={this.toggleQuantity.bind(this)}> used.</span> </td>
        <td>   
           <DateRangePicker
           ref={element => (this.fieldElement = element)}
           appendToBody
          startDate={startDate}
          startDateId={START_DATE}
          endDate={endDate}
          endDateId={END_DATE}
          onDatesChange={dates => handleDatesChange(dates)}
          onFocusChange={focus => focusInput(focus)}
          focusedInput={focusedInput}
          numberOfMonths={1}
          isOutsideRange={() => false}
          renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
            <div style={{ display: 'flex', justifyContent: 'center' , fontSize: '15' }}>
              <div>
                <select
                  value={month.month()}
                  onChange={(e) => { onMonthSelect(month, e.target.value); }}
                >
                  {moment.months().map((label, value) => (
                    <option value={value}>{label}</option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  value={month.year()}
                  onChange={(e) => { onYearSelect(month, e.target.value); }}
                >
                  <option value={moment().year() - 6}>{moment().year() - 6}</option>
                <option value={moment().year() - 5}>{moment().year() - 5}</option>
                <option value={moment().year() - 4}>{moment().year() - 4}</option>
                <option value={moment().year() - 3}>{moment().year() - 3}</option>
                  <option value={moment().year() - 2}>{moment().year() - 2}</option>
                  <option value={moment().year() - 1}>{moment().year() - 1}</option>
                  <option value={moment().year()}>{moment().year()}</option>
                  <option value={moment().year() + 1}>{moment().year() + 1}</option>
                  <option value={moment().year() + 2}>{moment().year() + 2}</option>
                  <option value={moment().year() + 3}>{moment().year() + 3}</option>
                  <option value={moment().year() + 4}>{moment().year() + 4}</option>
                  <option value={moment().year() + 5}>{moment().year() + 5}</option>
                  <option value={moment().year() + 6}>{moment().year() + 6}</option>
                  <option value={moment().year() + 7}>{moment().year() + 7}</option>
                  <option value={moment().year() + 8}>{moment().year() + 8}</option>
                  <option value={moment().year() + 9}>{moment().year() + 9}</option>
              
                </select>
              </div>
            </div>
          )}
          small
        />
        </td>
        <td>
          {saving ? <BeatLoader loading={saving} /> : <React.Fragment> {changed && <button onClick={(e) => handleSubmit(e)} className='license-btn' ><img alt='Save License' className='icon-save' src='/img/icon-license-save.svg' /></button>}
            <button disabled={deleting} type='button' onClick={showPrompt} className='license-btn' >{deleting ? <BeatLoader loading={deleting} /> : <img
              className='icon-license'
              src={`/img/icon-license-delete.svg`}
              alt='Delete Licenses'
            />}</button></React.Fragment>}
        </td>
      </tr>
        {error && <tr><td colSpan='12'><Alert>{error}</Alert></td></tr>}
        <Modal isOpen={this.state.showModal} toggle={showPrompt} >
              <ModalHeader>Confirm Delete</ModalHeader>
              <ModalBody>Do you want to continue?</ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleDelete}>Yes</Button>{' '}
                <Button color="secondary" onClick={showPrompt}>No</Button>
              </ModalFooter>
            </Modal>
        </React.Fragment>
    )
  }
}

export default ManageLicenseRow


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/ManageLicenseRow.js